import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useContext } from 'react';
import { Button } from 'semantic-ui-react';
import { MAX_LINKS_TO_SHOW, SEE_LESS, SEE_MORE } from './AccordionLinks.constants';
import InternalLink from '../../../../../../../../atoms/InternalLink';
import { SiteNavigationLinkPropType } from '../../../../../../../../services/proptypes';
import Accordion from '../../../../../../../foundation/components/Accordion';
import Icon from '../../../../../../../foundation/components/Icon';
import { NavigationContext } from '../../../../Navigation.context';
import NavigationLink from '../../../Link';
import { generateKey } from '../../../Links/Links.utils';
import { CATEGORY_NAVIGATION_MODE, ITEM_NAVIGATION_MODE } from '../../PopupAccordionMenuLink.constants';
import { NavigationModePropType } from '../../PopupAccordionMenuLink.types';
import './AccordionLinks.less';
var defaultProps = {
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  onLinkClick: function onLinkClick() {
    return null;
  },
  active: false,
  navigationMode: ITEM_NAVIGATION_MODE,
  onToggle: function onToggle() {
    return null;
  }
};
export default function AccordionLinks(_ref) {
  var link = _ref.link,
    maxLinksToShow = _ref.maxLinksToShow,
    onLinkClickProp = _ref.onLinkClick,
    navigationMode = _ref.navigationMode,
    onToggle = _ref.onToggle,
    active = _ref.active;
  var _useContext = useContext(NavigationContext),
    setToggled = _useContext.setToggled;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAllLinks = _useState2[0],
    setShowAllLinks = _useState2[1];
  function toggleShowAllLinks() {
    setShowAllLinks(function (previousShowAllLinks) {
      return !previousShowAllLinks;
    });
  }
  var title = link.title,
    slug = link.slug,
    childPages = link.childPages;
  var totalChildPages = childPages.length;
  var linksToShow = showAllLinks ? totalChildPages : maxLinksToShow;
  var finalChildPages = childPages.slice(0, linksToShow);
  var isItemNavigationMode = navigationMode === ITEM_NAVIGATION_MODE;
  var isCategoryNavigationMode = navigationMode === CATEGORY_NAVIGATION_MODE;
  function onLinkClick() {
    // close navigation bar when a link is clicked
    setToggled(false);
    onLinkClickProp();
  }
  function onAccordionTitleClick() {
    if (isCategoryNavigationMode) {
      onLinkClick();
    } else {
      onToggle();
    }
  }
  function getAccordionTitleContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement(Icon, {
      iconName: active ? 'angle-down' : 'angle-right'
    }));
  }
  return /*#__PURE__*/React.createElement(Accordion, null, isCategoryNavigationMode && /*#__PURE__*/React.createElement(InternalLink, {
    active: active,
    onClick: onAccordionTitleClick,
    to: slug,
    label: title,
    className: "title"
  }, getAccordionTitleContent()), isItemNavigationMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion.Title, {
    active: active,
    onClick: onAccordionTitleClick
  }, getAccordionTitleContent()), /*#__PURE__*/React.createElement(Accordion.Content, {
    active: active
  }, /*#__PURE__*/React.createElement(React.Fragment, null, finalChildPages.map(function (_ref2) {
    var childTitle = _ref2.title,
      childUrl = _ref2.url,
      childSlug = _ref2.slug;
    var childKey = generateKey(childTitle, childUrl, childSlug);
    return /*#__PURE__*/React.createElement(NavigationLink, {
      key: childKey,
      title: childTitle,
      url: childUrl,
      slug: childSlug,
      onClick: onLinkClick
    });
  }), totalChildPages > MAX_LINKS_TO_SHOW && /*#__PURE__*/React.createElement(Button, {
    className: "show-more",
    content: showAllLinks ? SEE_LESS : SEE_MORE,
    onClick: toggleShowAllLinks
  })))));
}
AccordionLinks.defaultProps = defaultProps;